import { FormType, NumberField } from "@hex-insights/forms";
import { InvoiceLineItemFormValues } from "../../FormUtilities";
import { ContractLineItemSelectField } from "../ContractLineItem";
import { InvoiceSelectField } from "../Invoice";
import { BaseFieldProps } from "../shared";

/**
 * Generic props for fields of the InvoiceLineItem model.
 */
type FieldProps<K extends keyof InvoiceLineItemFormValues.Base = keyof InvoiceLineItemFormValues.Base> = BaseFieldProps<
	Pick<InvoiceLineItemFormValues.Base, K>
>;

/**
 * Field component for the `displayOrder` field of the InvoiceLineItem model.
 */
export function DisplayOrder({ formState, ...props }: FieldProps<"displayOrder">) {
	return (
		<NumberField
			formState={formState}
			name="displayOrder"
			optional={FormType.isCreate(formState.formType)}
			validationUnit={1}
			{...props}
		/>
	);
}

/**
 * Field component for the `amount` field of the InvoiceLineItem model.
 */
export function Amount({ formState, ...props }: FieldProps<"amount">) {
	return <NumberField formState={formState} name="amount" validationUnit={1} unit={100} {...props} />;
}

export namespace ContractLineItem {
	export type SelectProps = FieldProps<"contractLineItemID"> &
		Omit<ContractLineItemSelectField.SelectProps<InvoiceLineItemFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `contractLineItem` edge of the InvoiceLineItem model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <ContractLineItemSelectField.Select formState={formState} name="contractLineItemID" {...props} />;
	}
}

export namespace Invoice {
	export type SelectProps = FieldProps<"invoiceID"> &
		Omit<InvoiceSelectField.SelectProps<InvoiceLineItemFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `invoice` edge of the InvoiceLineItem model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <InvoiceSelectField.Select formState={formState} name="invoiceID" {...props} />;
	}
}
